import { render, staticRenderFns } from "./addCurrency.vue?vue&type=template&id=fa30f8fa&scoped=true&"
import script from "./addCurrency.vue?vue&type=script&lang=ts&"
export * from "./addCurrency.vue?vue&type=script&lang=ts&"
import style0 from "./addCurrency.vue?vue&type=style&index=0&id=fa30f8fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa30f8fa",
  null
  
)

export default component.exports